import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { Router } from '@angular/router';
import { ChatMessage } from '../interfaces/chat.interface';
import { ModalService } from '@features/modals/services/modal.service';
import { CostComponent } from '@core/components/cost/cost.component';
import { CasesService } from '@features/cases/services/cases.service';
import { RewardsService } from '@features/rewards/services/rewards.service';
import { CaseReward } from '@features/rewards/interfaces/rewards.interface';

@Component({
  selector: 'app-supply-drop-message',
  standalone: true,
  imports: [CostComponent, DecimalPipe],
  templateUrl: './supply-drop-message.component.html',
  styleUrl: './supply-drop-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SupplyDropMessageComponent {
  private readonly modalService = inject(ModalService);
  private readonly router = inject(Router);
  private readonly casesService = inject(CasesService);
  private readonly rewardsService = inject(RewardsService);

  message = input.required<ChatMessage>();

  openCaseSkinsModal() {
    const startData = this.message().__supplyDropStart;
    const endData = this.message().__supplyDropEnd;
    const caseItem = startData?.caseItem ?? endData?.caseItem;

    if (caseItem) {
      const rewardCase = this.rewardsService.rewardsWithProgress()
        .find((r): r is CaseReward => r.type === 'case' && r.reward.link.toLowerCase() === caseItem.link.toLowerCase());

      const fullCaseItem = rewardCase?.reward
        ?? this.casesService.findCaseByLink(caseItem.link)
        ?? caseItem;
      this.modalService.openModal('CaseBattlesCaseSkinsModalComponent', {
        caseItem: fullCaseItem,
        balance: 'skins',
        showPrice: false,
        responsiveImage: true,
      });
    }
  }

  openUserProfile() {
    const endData = this.message().__supplyDropEnd;
    if (endData?.winner) {
      this.modalService.openModal('UserProfileModal', {
        user: endData.winner,
      });
    }
  }

  navigateToRewards() {
    this.router.navigate(['/rewards']);
  }

  navigateToVerify() {
    window.open('https://www.random.org/', '_blank', 'noopener,noreferrer');
  }
}
